<template>
  <header>
    <nav class="bg-white border-gray-200 px-4 lg:px-6 py-5">
      <div class="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl">
        <LogoApp />
        <AuthentificationBouton />
        <MenuHeader />
      </div>
    </nav>
  </header>
</template>

<script>
import LogoApp from "@/components/logo.vue";
import MenuHeader from "@/components/header/MenuHeader.vue";
import AuthentificationBouton from "@/components/header/AuthentificationBouton.vue";

export default {
  name: 'HeaderApp',
  components: {AuthentificationBouton, MenuHeader, LogoApp}
}
</script>